import axios from 'axios';
import API_CONFIG from '../config/api';
import { translateVi } from '../i18n/LocaleContext';

const API_URL = API_CONFIG.getApiUrl(API_CONFIG.ENDPOINTS.BANK);

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

export const bankService = {
  // Lấy tất cả banks
  getBanks: async () => {
    try {
      const response = await axios.get(API_URL, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy danh sách ngân hàng'));
    }
  },

  // Lấy bank mặc định
  getDefaultBank: async () => {
    try {
      const response = await axios.get(`${API_URL}/default`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Chưa cấu hình ngân hàng'));
    }
  },

  // Thêm bank mới
  configBank: async (bankData) => {
    try {
      const response = await axios.post(`${API_URL}/config`, bankData, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể thêm ngân hàng'));
    }
  },

  // Cập nhật bank
  updateBank: async (bankId, bankData) => {
    try {
      const response = await axios.put(`${API_URL}/${bankId}`, bankData, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể cập nhật ngân hàng'));
    }
  },

  // Xóa bank
  deleteBank: async (bankId) => {
    try {
      const response = await axios.delete(`${API_URL}/${bankId}`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể xóa ngân hàng'));
    }
  },

  // Set bank làm mặc định
  setDefaultBank: async (bankId) => {
    try {
      const response = await axios.post(`${API_URL}/${bankId}/set-default`, {}, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể đặt làm mặc định'));
    }
  }
};
